import { Box, Paper, Slide, Stack, Typography } from "@mui/material"
import RadioLabel from "../../../../components/ui/RadioLabel"

function Step({ steps, index, onChangeFun, nextBtnFun, formData }) {

  return (
    <Slide direction="left" in={true} timeout={500} key={index}>
      <Paper
        sx={{
          p: 3,
          mt: 3,
          borderRadius: "6px",
          boxShadow: "0 0 20px 0 #00000020"
        }}
      >
        <Stack spacing={3}>
          {steps?.map((step, i) => (
            <Box key={i}>
              <Typography
                sx={{
                  mb: 2,
                  fontSize: "18px",
                  fontWeight: "500",
                  color: "other.color1"
                }}
              >{i + 1}. {step?.que}
              </Typography>
              {!step?.type ?
                <Stack spacing={2}>
                  {step?.options?.map((option, i) => (
                    <RadioLabel
                      key={i}
                      option={option}
                      name={step?.name}
                      radioIcon={false}
                      value={option?.value}
                      label={option?.label}
                      image={option?.image}

                      onChangeFun={(e) => {
                        formData.current[step.name] = e.target.value;
                        if (typeof onChangeFun === "function") {
                          onChangeFun(e);
                        }
                        nextBtnFun();

                      }}

                    // onClick={nextBtnFun}
                    />

                  ))
                  }
                </Stack> :
                <Stack spacing={2}>
                  {step?.options?.map((option, i) => (
                    <RadioLabel
                      key={i}
                      value={option?.value}
                      type="checkbox"
                      name={step?.name + i}
                      label={option?.label}
                      image={option?.image}
                      onChangeFun={(e) => {
                        const isChecked = e.target.checked;
                        const val = option.value;

                        if (!Array.isArray(formData.current[step.name])) {
                          formData.current[step.name] = [];
                        }

                        if (isChecked) {
                          formData.current[step.name] = [...formData.current[step.name], val];
                        } else {
                          formData.current[step.name] = formData.current[step.name].filter(item => item !== val);
                        }

                        if (typeof onChangeFun === "function") {
                          onChangeFun(e);
                        }
                      }}
                    />
                  ))
                  }
                </Stack>
              }
            </Box>
          ))
          }
        </Stack>
      </Paper>
    </Slide>
  )
}

export default Step